<template>
  <modal-frame
    :submit="submit"
    :shape-width="600"
    :shape-height="450"
    :disable-cancel-button="true"
    class="modal-frame"
  >
    <div class="title-wrapper">
      <span class="title">{{ param.email }} 유저 설정 변경</span>
    </div>

    <div class="contents-wrapper">
      <div class="contents">
        <p class="contents-header">이메일</p>
        <div class="contents-text">
          <layout-input v-model="email" width="300px" placeholder="이메일을 입력해주세요." />
        </div>
      </div>
      <div class="contents">
        <p class="contents-header">전화번호</p>
        <div class="contents-text">
          <layout-input v-model="phone" width="300px" placeholder="전화번호를 입력해주세요." />
        </div>
      </div>
      <div class="contents">
        <p class="contents-header">암호</p>
        <div class="contents-text">
          <layout-input v-model="password" width="300px" placeholder="암호를 입력해주세요." />
        </div>
      </div>
    </div>
  </modal-frame>
</template>

<script>
import LayoutInput from "@/spa/components/LayoutInput";
import ModalFrame from "../ModalFrame";

export default {
  name: "ModalModifyWpUserState",
  components: {
    ModalFrame,
    LayoutInput
  },
  props: {
    param: Object
  },
  methods: {
    async submit() {
      let message = "";

      // this.editable = {
      //   id: this.param.id,
      //   email: this.email,
      //   password: this.password
      // };

      try {
        await this.$store.dispatch("modifyWpUser", {
          id: this.param.id,
          email: this.email,
          phone: this.phone,
          password: this.password
        });
        message = `${this.param.email} 계정 설정을 변경하였습니다.`;
      } catch (err) {
        message = "문제가 있어 설정 변경을 하지 못했습니다.";
      }

      this.$modal.clearComponent();
      this.$toast(message);
      this.$table.updateField();
    }
  },
  data() {
    return {
      editable: {},
      email: this.param.email,
      phone: this.param.phone,
      password: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.modal-frame {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;

  .title-wrapper {
    display: flex;
    justify-content: flex-start;
    padding: 24px 32px;

    .title {
      color: rgb(55, 168, 175);
      font-size: 22px;
    }
  }

  .contents-wrapper {
    display: flex;
    padding: 0 32px;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: column;

    margin-top: 30px;
    margin-bottom: 20px;

    .contents {
      display: flex;
      flex-direction: row;
      padding-left: 15px;
      width: 100%;

      margin-bottom: 20px;

      .contents-header {
        flex: 1;
        font-size: 20px;
        text-align: left;

        border-right: 1px solid rgba(0, 0, 0, 0.2);
        margin: 0 20px 0 0;

        color: rgba(0, 0, 0, 0.5);
      }

      .contents-text {
        flex: 2;

        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/modal/board-modal/ModalModifyWpUserState.vue